<template>
  <div>
    <div class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100 leading-normal">
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Request ID
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Patient Name
              </div>
            </th>            
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Requesting Doctor
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Request Date/Time
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Imaging Requested
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Priority
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Status
              </div>
            </th>
            <th scope="col" class="py-3 px-6"></th>
          </tr>
        </thead>
        <tbody class="text-gray-600 text-sm font-light">
          <tr v-for="data in laboratory_queue" :key="data.id" class="border-b border-gray-200 hover:bg-gray-100">
            <td class="py-3 px-6 text-left whitespace-nowrap">{{ data.id }}</td>
            <td class="py-3 px-6 text-left">{{ data.name }}</td>
            <td class="py-3 px-6 text-left">{{ data.doctor }}</td>
            <td class="py-3 px-6 text-left">{{ data.date }}</td>
            <td class="py-3 px-6 text-left">{{ data.test }}</td>
            <td class="py-3 px-6 text-left">
              <span :class="getPriorityClass(data.priority)" class="px-2 py-1 rounded-full text-xs">
                {{ data.priority }}
              </span>
            </td>
            <td class="py-3 px-6 text-left">
              <span :class="getStatusClass(data.status)" class="px-2 py-1 rounded-full text-xs">
                {{ data.status }}
              </span>
            </td>
            <td class="py-3 px-6 text-left">
              <button @click="viewLabRequest(data.id)" class="bg-custom-yellow hover:bg-orange-600 text-white font-bold py-1 px-3 rounded">
                View
              </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
    <div class="flex justify-center gap-4 mt-4">
      <button disabled
        class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button">
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
          viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m15 19-7-7 7-7" />
        </svg>
        Previous
      </button>
      <div class="flex items-center gap-2">
        <button
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg bg-custom-blue text-center align-middle font-medium text-white shadow-md shadow-custom-blue/10 transition-all hover:shadow-lg hover:shadow-custom-blue/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            1
          </span>
        </button>
        <button
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            2
          </span>
        </button>
        <button
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            3
          </span>
        </button>
        <button
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            4
          </span>
        </button>
        <button
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            5
          </span>
        </button>
      </div>
      <button
        class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button">
        Next
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
          viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m9 5 7 7-7 7" />
        </svg>
      </button>
    </div>

    <ConsultationPatientQueueModal :show="showConsultationModal" :patientId="selectedPatientId"
      @close="closeConsultationModal" @submit="handleAppointmentSubmit" />
  </div>
</template>
<script>
//   import CustomButton from "@/components/CustomButton.vue";
import ConsultationPatientQueueModal from "@/views/modals/ConsultationPatientQueueModal.vue";

export default {
  name: "ReceptionPatientQueueTab",
  components: {
    //   CustomButton,
    ConsultationPatientQueueModal,
  },
  created() {
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showConsultationModal: false,
      selectedPatientId: null,
      laboratory_queue: [
        { id: 'R01', name: 'Max Kimani', test: 'Uranalysis', doctor: 'Dr. Caroline', date: 'July 14, 2024 3:46PM', priority: 'Normal', status: 'New' },
        { id: 'R02', name: 'John Okari', test: 'Kidney', doctor: 'Dr. Richard', date: 'July 14, 2024 3:46PM', priority: 'STAT', status: 'New' },
        { id: 'R03', name: 'Beatrice Cherono', test: 'Prenatal', doctor: 'Dr. Michael', date: 'July 14, 2024 3:46PM', priority: 'Urgent', status: 'In progress' },
        { id: 'R04', name: 'Gabriel Mwema', test: 'Thyroid', doctor: 'Dr. Caroline', date: 'July 14, 2024 3:46PM', priority: 'STAT', status: 'In progress' },
        { id: 'R05', name: 'Arnold Mwiti', test: 'Uranalysis', doctor: 'Dr. Michael', date: 'July 14, 2024 3:46PM', priority: 'Normal', status: 'Completed' },
        { id: 'R06', name: 'James Karanja', test: 'Thyroid', doctor: 'Dr. Richard', date: 'July 14, 2024 3:46PM', priority: 'STAT', status: 'Completed' },
        { id: 'R07', name: 'Peter Ndichu', test: 'Thyroid', doctor: 'Dr. Michael', date: 'July 14, 2024 3:46PM', priority: 'Urgent', status: 'Completed' },
        { id: 'R08', name: 'Felix Kimtai', test: 'Kidney', doctor: 'Dr. Caroline', date: 'July 14, 2024 3:46PM', priority: 'STAT', status: 'Rejected' },
        { id: 'R09', name: 'Chepkoech Mercy', test: 'Uranalysis', doctor: 'Dr. Michael', date: 'July 14, 2024 3:46PM', priority: 'Normal', status: 'Rejected' },
        { id: 'R10', name: 'Mary Muthoni', test: 'Kidney', doctor: 'Dr. Richard', date: 'July 14, 2024 3:46PM', priority: 'Urgent', status: 'Rejected' },
      ],
    };
  },
  computed: {
    getTriageColor() {
      return (triageCode) => {
        switch (triageCode) {
          case 'Below 8':
            return 'bg-red-500';
          case '9-13':
            return 'bg-custom-yellow';
          case '14':
            return 'bg-yellow-200';
          case '15':
            return 'bg-green-500';
          case 'Code Blue':
            return 'bg-blue-500';
          default:
            return '';
        }
      };
    },
  },
  methods: {
    getPriorityClass(priority) {
      switch (priority) {
        case 'STAT': return 'bg-red-100 text-red-800';
        case 'Urgent': return 'bg-yellow-100 text-yellow-800';
        default: return 'bg-green-100 text-green-800';
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 'New': return 'bg-blue-100 text-blue-800';
        case 'In progress': return 'bg-yellow-100 text-yellow-800';
        case 'Completed': return 'bg-green-100 text-green-800';
        case 'Rejected': return 'bg-red-100 text-red-800';
        default: return 'bg-gray-100 text-gray-800';
      }
    },
    viewLabRequest(id) {
      this.$router.push({ name: 'RadiologyRequestDetails', params: { radiology_request_id: id } });
    }
  },
};
</script>

<style lang="css" scoped></style>